import styled from "styled-components";

export const SelectAligner = styled.div`
  margin: 0 auto 20px;
  max-width: 860px;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
  }
`;
export const SelectDiv = styled.div`
  margin-bottom: 10px;
  width: 200px;
  height: 100%;
  border-radius: 5px;
`;

export const InputDataDiv = styled.div`
  width: 200px;
  height: 32px;
  display: flex;
  position: relative;
`;
export const Input = styled.input`
  padding: ${({ padding }) => (padding ? padding : "5px 30px")};
  width: 200px;
  height: 100%;
  border: none;
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  border-radius: 4px;
  background: #fff;
`;
export const SearchIcon = styled.img`
  width: 16px;
  height: 16px;
  position: absolute;
  top: 7px;
  left: 6px;
  z-index: 10;
`;
export const RemoveContentButton = styled.button`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 10;
`;
export const RemoveContentIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const TableHeader = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  width: 100%;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const HeaderSection = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
  position: relative;
`;
export const HeaderButton = styled.button`
  padding: 2px 5px;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: #d8d8d8;
  cursor: pointer;
`;
export const SetBtnImg = styled.img`
  margin-left: 5px;
  width: 15px;
  height: 15px;
`;
export const HeaderText = styled.p`
  padding: 2px 0;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
`;
export const NoPatientsText = styled.p`
  margin: auto;
  width: 100%;
  max-width: 860px;
  font-size: 18px;
  font-weight: 500;
  color: #808080;
  @media (max-width: 910px) {
    margin: 0 auto;
    width: 85%;
  }
`;
